import axios, { AxiosHeaders } from 'axios';
import { getAuthHeaders } from './auth.js';

// Create axios instance with default timeout
const axiosInstance = axios.create({
  timeout: 10000, // 10 seconds
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const authHeaders = await getAuthHeaders();
    const mergedHeaders =
      config.headers instanceof AxiosHeaders
        ? config.headers
        : new AxiosHeaders(config.headers);

    Object.entries(authHeaders).forEach(([key, value]) => {
      if (value !== undefined) {
        mergedHeaders.set(key, value);
      }
    });

    config.headers = mergedHeaders;
    console.log(`Making API request to: ${config.url}`);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message,
    });

    // Handle different error types
    if (error.code === 'ECONNABORTED') {
      console.error('Request timeout');
    } else if (!error.response) {
      console.error('Network error - no response received');
    } else if (error.response.status >= 500) {
      console.error('Server error:', error.response.status);
    } else if (error.response.status >= 400) {
      console.error('Client error:', error.response.status);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
